









export default {
  name: 'CanvasSkeleton',
};
